import { render, staticRenderFns } from "./SubSidebarLayout.vue?vue&type=template&id=de248142&scoped=true&"
import script from "./SubSidebarLayout.vue?vue&type=script&lang=js&"
export * from "./SubSidebarLayout.vue?vue&type=script&lang=js&"
import style0 from "./SubSidebarLayout.vue?vue&type=style&index=0&id=de248142&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de248142",
  null
  
)

export default component.exports